import classnames from 'classnames';
import { useFormContext } from 'react-hook-form';
import { IconButton } from '@shared/ui';
import * as st from './styles.module.scss';

interface Props {
  id: number;
}

export const PeriodicityMobile = ({ id }: Props): JSX.Element => {
  /**
   * TODO: Написать стили для кнопок periodicity
   */
  const { watch, setValue } = useFormContext();

  const programVideos = watch('exercises');
  const excluded = watch('excluded_videos_period');

  const isChecked = (day: number, id: number, excluded: number[][]) => {
    return !!!excluded[day]?.find((el) => el === id);
  };

  const checkVideo = (day: number, id: number, excluded: number[][], videos: number[]) => {
    const allVideos = [...videos];
    let currentExcluded = excluded[day];
    const finalExcluded = [...excluded];

    if (currentExcluded.includes(id)) {
      currentExcluded = currentExcluded.filter((video) => video !== id);
      finalExcluded[day] = [...currentExcluded];
    } else {
      const filter = allVideos.filter(
        (videoId: number) => videoId === id || currentExcluded.includes(videoId)
      );
      finalExcluded[day] = [...filter];
    }
    setValue('excluded_videos_period', finalExcluded, { shouldDirty: true });
    return;
  };

  const days = [0, 1, 2, 3, 4, 5, 6];

  return (
    <>
      {days.map((day) => {
        const isActive = isChecked(day, id, excluded);
        const buttonVariant = isActive ? 'activeDark' : 'dark';
        const buttonClass = classnames({
          [st.button]: isActive,
          [st.uncheck]: !isActive,
        });
        const dayLabel = isActive ? day + 1 : '-';

        return (
          <IconButton
            size="medium"
            variant={buttonVariant}
            type="button"
            key={day}
            className={buttonClass}
            onClick={(e) => {
              e.stopPropagation();
              checkVideo(day, id, excluded, programVideos);
            }}
          >
            <span className={st.day}>{dayLabel}</span>
          </IconButton>
        );
      })}
    </>
  );
};
